import { SelectionModel } from '@angular/cdk/collections';
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { Module } from 'src/app/model/module.modal';
import { AccessControlService } from 'src/app/services/access-control.service';
@Component({
  selector: 'app-module-permission',
  templateUrl: './module-permission.component.html',
  styleUrls: ['./module-permission.component.css']
})
export class ModulePermissionComponent implements OnInit {
  selectedModules = new SelectionModel<Module>(true, []);
  visibileModules = new SelectionModel<Module>(true, []);
  disabledModules = new SelectionModel<Module>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  application_name: any;
  dataSource: MatTableDataSource<Module>
  isLoading: boolean = false;
  moduleList: Array<Module>;
  displayedColumns = ['module_name', 'value', 'isVisible', 'disabled'];
  clientId: string;
  appId: string;
  isClientMode: boolean;
  constructor(private route: ActivatedRoute, private router: Router, private accessControlService: AccessControlService,
    private toastrService: ToastrService) {
    this.route.queryParamMap.subscribe((param: ParamMap) => {
      this.application_name = param.get("app");
    });
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.clientId = param.get("clientId");
      this.appId = param.get("applicationId");
    });
    if (this.router.url.indexOf('client') > -1)
      this.isClientMode = true;
  }
  ngOnInit() {
    this.isLoading = true;
    this.accessControlService.getModulebyApplication_Id(this.appId).pipe(map((data: any) => {
      if (this.isClientMode) {
        data.rows = data.rows.filter(x => { return x.license.includes(this.clientId) });
        return data;
      } else {
        return data;
      }
    })).subscribe((res: any) => {
      this.isLoading = false;
      this.moduleList = Array<Module>();
      if (res.rows) {
        this.moduleList = res.rows.map((module) => {
          let mapModule = {
            _id: module._id, module_name: module.module_display_name, value: module.license ?
              (module.license || []).some(x => x == this.clientId) : true,
            isVisible: module.visibileForClient ? (module.visibileForClient || []).some(x => x == this.clientId) : true, isDisable: (module.disabledForClient || []).some(x => x == this.clientId)
          }
          if (mapModule.value == true)
            this.selectedModules.select(mapModule);
          if (mapModule.isVisible)
            this.visibileModules.select(mapModule);
          if (mapModule.isDisable)
            this.disabledModules.select(mapModule);
          return mapModule
        })
        this.dataSource = new MatTableDataSource(this.moduleList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }, error => {
      this.isLoading = false;

    })
  }
  onSave() {
    this.isLoading = true;
    let selectedItems = this.selectedModules.selected;
    let excludedItems = this.moduleList.filter((module) => {
      return module.value && !selectedItems.some(x => x._id == module._id);
    })

    let visibleSeletedItems = this.visibileModules.selected;
    let visibileExcluded = this.moduleList.filter((module) => {
      return module.isVisible && !visibleSeletedItems.some(x => x._id == module._id);
    })

    let disabledSeletedItems = this.disabledModules.selected;
    let disabledExcluded = this.moduleList.filter((module) => {
      return module.isDisable && !disabledSeletedItems.some(x => x._id == module._id);
    })
    this.accessControlService.addModuleLicense({
      application_id: this.appId, selectedModules: selectedItems.map((item) => { return item._id; }),
      excludedModules: excludedItems.map(item => { return item._id }),
      clientId: this.clientId, visibleExcluded: visibileExcluded.map(item => { return item._id }),
      visibleModules: visibleSeletedItems.map(item => { return item._id }),
      disabledModules: disabledSeletedItems.map(item => { return item._id }),
      disabledExcluded: disabledExcluded.map(item => { return item._id })
    }).subscribe((res: any) => {
      if (res.message)
        this.toastrService.success("Records saved successfully")
      else
        this.toastrService.error("Something went wrong")

      this.isLoading = false;

    }, error => {
      this.toastrService.error(error.error)
      this.isLoading = false;

    })
  }
  isAllSelected(type: any) {
    let numSelected = -1, numRows = this.dataSource.data.length;
    if (type == 'license') {
      numSelected = this.selectedModules.selected.length;
    }
    else if (type == 'visible') {
      numSelected = this.visibileModules.selected.length;
    } else {
      numSelected = this.disabledModules.selected.length;
    }
    return numSelected === numRows;
  }
  masterToggle(type: any, event: MatCheckboxChange) {
    if (type == 'license') {
      if (event.checked == false) {
        this.visibileModules.clear()
        this.disabledModules.clear();
        this.selectedModules.clear()
      } else
        this.isAllSelected(type) ?
          this.selectedModules.clear() :
          this.dataSource.data.forEach(row => { this.selectedModules.select(row); this.visibileModules.select(row) });
    }
    else if (type == 'visible') {
      if (event.checked == false) {
        this.visibileModules.clear()
        this.disabledModules.clear();
      }
      else
        this.isAllSelected(type) ?
          this.visibileModules.clear() :
          this.dataSource.data.forEach(row => {
            if (this.selectedModules.isSelected(row))
              this.visibileModules.select(row)
          });
    } else {
      if (event.checked == false)
        this.disabledModules.clear()
      else
        this.isAllSelected(type) ?
          this.disabledModules.clear() :
          this.dataSource.data.forEach(row => {
            if (this.visibileModules.isSelected(row))
              this.disabledModules.select(row)

          });
    }
  }
  onVisibilityChange(event: MatCheckboxChange, row: any) {
    if (event && (this.selectedModules.isSelected(row) || event.checked == false)) {
      this.visibileModules.toggle(row)
      if (event.checked == false) {
        this.disabledModules.deselect(row);
      }
    }
    else {
      event.source.toggle()
    }
  }
  onLicenseChange(event: MatCheckboxChange, row: any) {
    this.selectedModules.toggle(row);
    if (event && event.checked == true) {
      this.visibileModules.select(row);
    } else {
      this.visibileModules.deselect(row);
      this.disabledModules.deselect(row);
    }
    // if (event.checked == false && this.visibileModules.isSelected(row))
    //   this.visibileModules.toggle(row);
  }
  onDisable(event: MatCheckboxChange, row: any) {
    if (event && (this.selectedModules.isSelected(row) && this.visibileModules.isSelected(row)) || event.checked == false)
      this.disabledModules.toggle(row)
    else {
      event.source.toggle()
    }
  }


}
